// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3e5a570e","453":"7f8b7a36"}[chunkId] + ".chunk.js";
};